export default __webpack_public_path__ + "static/media/CC_Questionnaire.beded0fa.pdf";